import {
    type ViewerCompatibilityResponseInput,
    viewerCompatibilityResponseSchema,
} from "./viewer-compatibility.contract.ts";

export function parseViewerCompatibilityResponse(
    value: ViewerCompatibilityResponseInput,
) {
    const parsed = viewerCompatibilityResponseSchema.safeParse(value);
    return parsed.success ? parsed.data : {};
}
